module.exports = __webpack_public_path__ + "assets/img/home-box4-bg.3e734991.png";